import { FC, JSX } from 'react'
import { Summary, SummaryType } from './Summary'
import { Wrapper, WrapperType } from './Wrapper'

export const Connector: FC & SummaryType & WrapperType = (): JSX.Element => (
  <></>
)

Connector.Summary = Summary
Connector.Wrapper = Wrapper
